import { ProFormRadio as OriginalProFormRadio } from '@ant-design/pro-components';
import { withWrap } from '../../utils/hoc';
const ProFormRadio = withWrap(OriginalProFormRadio);
ProFormRadio.Group = withWrap(OriginalProFormRadio.Group);
export default ProFormRadio;
